import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDialogHandle } from "../../../actions/dialog";
import { IReduxAppState } from "../../../reducers";
import { generateSearchBody } from "../../../services/SearchController";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import { OpenCollectionDialog } from "../Ui/OpenCollectionDialog";
import Styles from '../../../scss/collectionPoint.module.scss';

/**Hook to check any orders inside of the collection point */
export function useCollectionPointCheck() {
    const { callAPI } = useAPIV2<{ count: number }>(APIExtensions.placedOrders, { onMountDisabled: true });
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId)

    async function checkItem(collectionItem: any, isDelete?: boolean) {
        setIsLoading(true);
        let isOkay = true;
        if (collectionItem.id) {
            const { data } = await callAPI(HTTPMethods.GET, { query: `collection_point/${collectionItem.id}/count`, params: { venue_id: selectedVenueId, collection_point_id: collectionItem.id } });
            if (data && data?.count > 0) {
                dispatch(setDialogHandle({
                    Component: OpenCollectionDialog,
                    ComponentProps: {
                        collectionItem,
                        orderCount: data?.count,
                        isDelete
                    },
                    canClose: true,
                    dialogTitle: " ",
                    isFormDialog: false,
                    styles: { className: Styles.CollectionPointDialog }
                }));
                isOkay = false;
            }
        }
        setIsLoading(false);
        return isOkay;
    }
    return { checkItem, isLoading };
}

export function createSearchBody(collectionPointId: string, venueId: string) {
    const filters = [
        {
            fieldName: "collection_point_id",
            value: collectionPointId
        },
        {
            fieldName: "venue_id",
            value: venueId
        },
        {
            fieldName: "order_status",
            value: [
                "PLACED",
                "FUNDS_RECEIVED",
                "ACCEPTED",
                "READY_FOR_COLLECTION",
            ]
        }
    ]
    return generateSearchBody(filters);
}

export function checkCollectionPointOrders(collectionPoints: any[], venueId: string) {
    const searchList = [];
    for (const collection of collectionPoints) {
        if (collection.id) {
            searchList.push({
                collectionItem: collection,
                filter: createSearchBody(collection.id, venueId)
            });
        }
    }
    return searchList;
}